 <!-- Main Page Start -->
 <section class="skillsWrap">
  <div class="left-sidebar">
    <app-sidebar></app-sidebar>
  </div>
  <div class="right-panel">

      <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="topHeader">
              <h2 class="mainTitle">Licenses / Certifications</h2>
              <a href="javascript:void(0)" routerLink="/language" class="skipBtn"> Skip </a>
          </div>
          <div class="row">
              <div class="col-md-6 col-lg-6  col-sm-12">
                  <div class="form-group">
                      <label>Name<span class="orangeText">*</span> </label>
                      <input type="text"  class="form-control upper" placeholder="Behavioural economics" formControlName="name">
                      <div class="text-danger" *ngIf="form.controls['name'].hasError('required') && showError">
                          *Please enter name.
                      </div>
                  </div>
              </div>
              <div class="col-md-6 col-lg-6 col-sm-12 ">
                  <div class="form-group">
                      <label>Attested by authority <span class="orangeText">*</span> </label>
                      <input type="text"  class="form-control upper" placeholder="Ogilvy consulting USA" formControlName="attestedByAuthority">
                      <div class="text-danger" *ngIf="form.controls['attestedByAuthority'].hasError('required') && showError">
                          *Please enter Attested by Authority.
                      </div>
                  </div>
              </div>
            

              <div class="col-md-6 col-lg-6 col-sm-12 ">
                  <div class="form-group">
                      <label>ID/Certificate No.</label>
                      <input type="text"  class="form-control" placeholder="Certificate Id - 304304"  formControlName="certificationNo" maxlength="60">
                      <div class="text-danger" *ngIf="form.controls['certificationNo'].hasError('required') && showError">
                          *Please enter ID Certificate No.
                      </div>
                  </div>
              </div>
              <div class="col-md-6 col-lg-6 col-sm-12 ">
                  <div class=" d-flex justify-content-between">
                      <div class="form-group">
                          <label> Issue date</label>
                          <div id="date-picker-example" class="datepicker">
                            <input type="text" autocomplete="off" class="form-control" placeholder="Enter date" bsDatepicker placement="bottom" [bsValue]="form.value.issuesedOn" [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" formControlName="issuesedOn" [maxDate]="maxDate" (keydown)="onKeyDown($event)">
                            <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                        </div>
                        <div class="text-danger" *ngIf="showError == true && form.controls['issuesedOn'].hasError('required')">*Please enter Issue date</div>
                      </div>

                      <div class="form-group">
                          <label>Expiry date (If any)</label>
                          <div id="date-picker-example" class="datepicker">
                            <input type="text" placeholder="Enter date"
                            class="form-control" bsDatepicker
                            [minDate]="form.value.issuesedOn == '' ? minDate : form.value.issuesedOn"
                            formControlName="expirydate"
                            [bsValue]="form.value.expirydate"
                            [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" (keydown)="onKeyDown($event)">
                            <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                        </div>
                        <div class="text-danger" *ngIf="showError == true && form.controls['expirydate'].hasError('required')">*Please enter expiry date</div>
                      </div>
                  </div>
              </div>
        
               <div class="col-md-12 co-sm-12 col-lg-12 ">
                  <div class="form-group">
                      <label> Certified URL </label>
                      <input type="text"  class="form-control" placeholder="www.splashdesignstudio.com" formControlName="credentialUrl">
                      <div class="text-danger" *ngIf="form.controls['credentialUrl'].hasError('required') && showError">
                          *Please enter Certified URL.
                      </div>
                      <div class="text-danger" *ngIf="form.controls['credentialUrl'].hasError('pattern') && showError">
                          *Please enter Valid Certified URL with https or http.
                      </div>
                  </div>
              </div>

          <div class="form-group col-md-12 co-sm-12 col-lg-12 bottom ">
            <input type="submit" value="Save"  class="commonBtn width50 mt-2"> 
          </div>
      </div>
      </form>
  </div>
</section>
